import imRequest from '../imRequest';
import { IM_API } from '../../constants/endpoints';

const BASE = `${IM_API}/customer-service`;

/** Member Support Session APIs (CS2A/CS6/CS8). */
export const supportSessionApi = {
  getChannelMode: () => imRequest.get(`${BASE}/channel-mode`),

  start: (data) => imRequest.post(`${BASE}/sessions/start`, data || {}),

  current: () => imRequest.get(`${BASE}/sessions/current`),

  leave: (sessionId, data) =>
    imRequest.post(`${BASE}/sessions/${sessionId}/leave`, data || {}),

  end: (sessionId, data) =>
    imRequest.post(`${BASE}/sessions/${sessionId}/end`, data || {}),

  disconnect: (sessionId) =>
    imRequest.post(`${BASE}/sessions/${sessionId}/disconnect`),

  resume: (sessionId) =>
    imRequest.post(`${BASE}/sessions/${sessionId}/resume`),

  conversation: () => imRequest.get(`${BASE}/conversation`),

  history: (params) =>
    imRequest.get(`${BASE}/sessions/history`, { params }),

  getSession: (sessionId) =>
    imRequest.get(`${BASE}/sessions/${sessionId}`),

  conversationSessions: (conversationId, params) =>
    imRequest.get(`${BASE}/conversations/${conversationId}/sessions`, { params }),

  submitRating: (sessionId, data) =>
    imRequest.post(`${BASE}/sessions/${sessionId}/rating`, data || {}),

  skipRating: (sessionId, params) =>
    imRequest.post(`${BASE}/sessions/${sessionId}/rating/skip`, null, { params }),
};
